import { SystemStyleObject } from '@chakra-ui/react';
import {
  getBorderWidthToken,
  getTypographyToken,
  ColorMode,
} from '@allergan-data-labs/alle-elements-core';

export const TAB_AND_MENU_BUTTON_WIDTH = '57px';

export const getTabsShowMoreMenuStyles = (
  selectedMenuItemRef?: React.RefObject<HTMLElement | null>,
  colorMode?: ColorMode,
  isFitted?: boolean
): SystemStyleObject => ({
  ...getTypographyToken('Body/Medium/Regular'),
  ...(!isFitted && { width: TAB_AND_MENU_BUTTON_WIDTH }),
  ...(isFitted && { flex: 1 }),
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: '2rem',
  mx: '0.25rem',
  whiteSpace: 'nowrap',
  borderRadius: 'Small',
  color: selectedMenuItemRef?.current
    ? `${colorMode}.Text/Brand/Interactive/Enable`
    : `${colorMode}.Text.Neutral.Default`,
  _selected: {
    color: selectedMenuItemRef?.current
      ? `${colorMode}.Text/Brand/Default`
      : `${colorMode}.Text/Neutral/Interactive/Active support`,
  },
  _hover: {
    color: selectedMenuItemRef?.current
      ? `${colorMode}.Text/Brand/Interactive/Hover`
      : `${colorMode}.Text/Neutral/Interactive/Hover`,
  },
  _focusVisible: {
    outlineWidth: getBorderWidthToken('Bold'),
    outlineStyle: 'solid',
    outlineColor: `${colorMode}.Border/Brand/Focus ring/Default`,
    boxShadow: 'none',
    outlineOffset: 2,
  },
  _active: {
    color: selectedMenuItemRef?.current
      ? `${colorMode}.Text/Brand/Interactive/Active support`
      : `${colorMode}.Text/Neutral/Interactive/Active support`,
  },
  '> span:nth-child(2)': {
    alignSelf: 'flex-start',
    paddingTop: '2',
  },
});

export const getMenuListStyles = (
  colorMode?: ColorMode
): SystemStyleObject => ({
  py: '0.25rem',
  boxShadow: 'Elevation/2',
  borderRadius: '0',
  borderWidth: '1px',
  borderColor: `${colorMode}.Border/Neutral/Subtle 2`,
  _focusVisible: {
    outlineWidth: getBorderWidthToken('Bold'),
    outlineStyle: 'solid',
    outlineColor: `${colorMode}.Border/Brand/Focus ring/Default`,
    outlineOffset: '0px',
    boxShadow: 'none',
  },
});

export const getMenuItemStyles = (
  colorMode?: ColorMode
): SystemStyleObject => ({
  ...getTypographyToken('Body/Medium/Regular'),
  height: '32px',
  color: `${colorMode}.Text/Neutral/Default`,
  _focusVisible: {
    bg: `${colorMode}.Container/Brand/Transparent interactive/Hover`,
    outlineWidth: getBorderWidthToken('Bold'),
    outlineStyle: 'solid',
    outlineColor: `${colorMode}.Border/Brand/Focus ring/Default`,
    outlineOffset: '0px',
    boxShadow: 'none',
  },
  _focus: {
    color: `${colorMode}.Text/Brand/Default`,
  },
  _hover: {
    bg: `${colorMode}.Container/Brand/Transparent interactive/Hover`,
  },
  _active: { color: `${colorMode}.Text/Brand/Default` },
});

export const getTabHiddenStyles = (): SystemStyleObject => ({
  visibility: 'hidden',
  position: 'absolute',
  width: TAB_AND_MENU_BUTTON_WIDTH,
});

export const getTabShowMoreMenuIconStyle = (): SystemStyleObject => ({
  mr: 12,
});

export const getTabShowMoreMenuChildrenStyle = (): SystemStyleObject => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});
